/** @jsxImportSource @emotion/react */
import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { css } from '@emotion/react'
import { Paper } from '@mui/material'

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger

type ContentProps = React.ComponentProps<typeof PopoverPrimitive.Content> & {
  defaultSideOffset?: number
}

export const PopoverContent = React.forwardRef<HTMLDivElement, ContentProps>(
  ({ children, defaultSideOffset = 6, sideOffset, ...props }, ref) => {
    return (
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          ref={ref}
          sideOffset={sideOffset ?? defaultSideOffset}
          {...props}
          css={css`
            z-index: 110;
            outline: none;
            border-radius: 8px;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px;
          `}
        >
          <Paper
            elevation={3}
            css={css`
              padding: 8px 12px;
            `}
          >
            {children}
          </Paper>
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    )
  },
)
PopoverContent.displayName = 'PopoverContent'
